/**
 * SearchPropertiesEditor Component
 * 
 * Property editor for Search block type.
 */

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchBlockProps } from '@/types/menuBuilder';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SearchPropertiesEditorProps {
  props: SearchBlockProps;
  onUpdate: (props: Partial<SearchBlockProps>) => void;
}

export const SearchPropertiesEditor = memo(function SearchPropertiesEditor({
  props,
  onUpdate,
}: SearchPropertiesEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      {/* Placeholder */}
      <div className="space-y-2">
        <Label>{t('menuBuilder.placeholder', 'Placeholder Text')}</Label>
        <Input
          value={props.placeholder || ''}
          onChange={(e) => onUpdate({ placeholder: e.target.value })}
          placeholder={t('menuBuilder.searchPlaceholder', 'Search menu...')}
        />
      </div>

      {/* Style */}
      <div className="space-y-2">
        <Label>{t('menuBuilder.searchStyle', 'Search Style')}</Label>
        <Select
          value={props.style}
          onValueChange={(value) =>
            onUpdate({ style: value as SearchBlockProps['style'] })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="rounded">
              {t('menuBuilder.rounded', 'Rounded')}
            </SelectItem>
            <SelectItem value="square">
              {t('menuBuilder.square', 'Square')}
            </SelectItem>
            <SelectItem value="minimal">
              {t('menuBuilder.minimal', 'Minimal')}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
});

export default SearchPropertiesEditor;
